<template>
  <div id="pricing">
    <div class="pricing">
      <h1>SEATING & PRICING</h1>
      <h6>
        Members receive the best ticket price across the season and have no
        fees.
      </h6>
      <div class="content">
        <img src="~images/seatingPricing/seating-map-3.png" />
        <div class="right">
          <span
            >Lower Level Seating starting at
            <h3>$90</h3>
            per game</span
          >
          <span
            >Upper Level seating starting at
            <h3>$49</h3>
            per game</span
          >
        </div>
        <a
          href="https://newyorkislanders.io-media.com/web/index.html"
          target="_blank"
          >View Seat Locations</a
        >
        <button @click.prevent="(e) => $emit('modalShow', 'show')">
          Get in touch
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, computed } from "vue";
import { useStore } from "vuex";

export default {
  name: "Pricing",

  setup() {
    const store = useStore();

    // State
    const state = reactive({
      accountFirstName: computed(
        () => store.getters["purl/getAccountFirstName"]
      ),
      memberSince: computed(() => store.getters["purl/getMemberSince"]),

      repInfo: computed(() => store.getters["purl/getAccountRep"]),

      account: computed(() => store.getters["purl/getAccounts"]),
      tenure: computed(() => store.getters["purl/getTenureLevel"]),
    });

    return { ...toRefs(state), store };
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
#pricing {
  background-image: url("~images/seatingPricing/bg-image.jpg");
  background-position: center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 100px 0 97px;

  .pricing {
    max-width: 1244px;
    width: 95%;

    h1 {
      color: #fff;
      text-align: center;
      font-family: Prompt;
      font-size: 96px;
      font-style: normal;
      font-weight: 900;
      line-height: 88px; /* 91.667% */
      letter-spacing: -0.305px;
      margin-bottom: 29px;

      @media screen and (max-width: 789px) {
        font-size: 48px;
        line-height: 48px;
      }
    }

    h6 {
      color: #fff;
      text-align: center;
      font-family: Prompt;
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      line-height: 36px; /* 150% */
      margin-bottom: 93px;

      @media screen and (max-width: 789px) {
        font-size: 18px;
        line-height: 24px;
        margin-bottom: 54px;
      }
    }

    .content {
      display: grid;
      grid-template: 3fr 1fr / 1fr 1fr;

      @media screen and (max-width: 1000px) {
        grid-template:
          "map" 3fr
          "seat-btn" 1fr
          "right" 3fr
          "form-btn" 1fr
          / 1fr;
      }

      img {
        width: 100%;
        max-width: 608px;

        @media screen and (max-width: 1000px) {
          margin: 0 auto;
          grid-area: map;
        }
      }

      .right {
        width: 100%;
        max-width: 614px;
        text-align: center;
        text-transform: uppercase;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        @media screen and (max-width: 1000px) {
          margin: 0 auto;
          grid-area: right;
        }

        span {
          color: #fff;
          text-align: center;
          margin: 0 auto;
          font-size: 24px;
          font-family: Prompt;
          text-transform: none;
          font-style: normal;
          font-weight: 400;
          line-height: 36px;
          display: inline-block;
          width: 100%;

          h3 {
            font-size: 64px;
            font-weight: 900;
            line-height: 62px;
            margin-bottom: 0;
          }

          &:first-of-type {
            border-bottom: 1px solid rgba($color: White, $alpha: 0.7);
            padding-bottom: 49px;
          }

          &:last-of-type {
            padding-top: 49px;
          }
        }
      }

      button,
      a {
        text-decoration: none;
        display: inline-block;
        text-transform: uppercase;
        text-align: center;
        width: max-content;
        height: min-content;
        padding: 18px 24px 18px;
        font-size: 18px;
        line-height: 18px;
        text-transform: uppercase;
        transition: all 0.2s linear;
        border-radius: 0;
        border: 2px solid transparent;
        outline: none;
        transform: scale(1);
        color: white;
        font-family: Prompt;
        background-color: #00468b;
        margin: auto;
        font-weight: 700;
        min-width: 255px;

        @media screen and (max-width: 1000px) {
          grid-area: form-btn;
        }

        &:hover {
          border: 2px solid white;
        }
      }

      a {
        @media screen and (max-width: 1000px) {
          grid-area: seat-btn;
        }
      }
    }
  }
}
</style>
